import { useNavigate } from 'react-router';
import React, { useLayoutEffect, useState } from 'react';
import useUser from '../../hooks/useUser';
import { sanitaizeUsername, validateUsername } from '../../utils/validation';
import { StyledBox, StyledGrid, StyledImageSection, StyledLoginSection } from './Login.styles';
import { Alert, Box } from '@mui/material';
import Logo from '../../components/UI/Logo';
import RegisterTeacherForm from '../../components/Auth/RegisterTeacher';
import * as userActions from '../../store/actions/user';
import { connect } from 'react-redux';

function RegisterTeacher(props) {
	const navigate = useNavigate();
	const [credentials, setCredentials] = useState({ role: 2, ...props.user });
	const { isAuthenticated } = useUser();
	const [buttonLoading, setButtonLoading] = useState(false);

	useLayoutEffect(() => {
		if (isAuthenticated) {
			navigate('/');
		}
	}, [isAuthenticated, navigate]);

	const onInputChange = (e) => {
		const { name, value } = e.target;
		setCredentials((prevState) => ({
			...prevState,
			[name]: value
		}));
	};

	const handleRegister = () => {
		if (validateFields(false)) {
			props.registerUser(credentials, navigate, setButtonLoading);
		}
	};

	const validateFields = (isResetPasswordForm) => {
		let sanitizedLastName;
		let sanitizedFirstName;

		if (!isResetPasswordForm) {
			if (!checkFieldsExist()) {
				return false;
			}

			const [firstName, lastName] = sanitaizeUsername(credentials.firstName, credentials.lastName);
			sanitizedFirstName = firstName;
			sanitizedLastName = lastName;
		}

		let isValidUsername;
		if (sanitizedFirstName && sanitizedLastName) {
			isValidUsername = validateUsername(sanitizedFirstName, sanitizedLastName);
		}

		if (!isValidUsername && !isResetPasswordForm) {
			props.updateUserError('Numele sau prenumele este invalid.');
			return false;
		}

		if (credentials.confirmPassword && credentials.confirmPassword !== credentials.password) {
			props.updateUserError('Parolele introduse nu sunt identice. Te rugam reincearca.');
			return false;
		}

		if (credentials.password && credentials.password.length < 8) {
			props.updateUserError('Parola introdusă nu este suficient de lungă.');
			return false;
		}
		return true;
	};

	const checkFieldsExist = () => {
		// check field exists
		if (!credentials.firstName) {
			const firstNameInput = document.getElementById('firstName');
			if (firstNameInput) firstNameInput.value = '';
			props.updateUserError('Prenumele introdus este invalid.');
			return false;
		}

		if (!credentials.lastName) {
			const lastNameInput = document.getElementById('lastName');
			if (lastNameInput) lastNameInput.value = '';
			props.updateUserError('Numele introdus este invalid.');
			return false;
		}

		if (!credentials.email) {
			const emailInput = document.getElementById('email');
			if (emailInput) emailInput.value = '';
			props.updateUserError('Email-ul introdus nu este valid.');
			return false;
		}
		return true;
	};

	return (
		<StyledGrid container>
			<StyledImageSection item xs={12} sm={12} md={7} isteacher={'true'}></StyledImageSection>
			<StyledLoginSection item xs={12} sm={12} md={5}>
				<Box
					display="flex"
					flexDirection="column"
					height="100%"
					alignItems="left"
					justifyContent="center"
				>
					<StyledBox>
						{props.statusMessage ? <Alert severity="error">{props.statusMessage}</Alert> : null}
						<Logo cancelRedirect={true} height="100px" />
						<RegisterTeacherForm
							onInputChange={onInputChange}
							handleRegister={handleRegister}
							error={props.error}
							updateError={props.updateUserError}
							buttonLoading={buttonLoading}
							setButtonLoading={(value) => {
								setButtonLoading(value);
							}}
							isStatusMessage={!!props.statusMessage}
						/>
					</StyledBox>
				</Box>
			</StyledLoginSection>
		</StyledGrid>
	);
}

const mapStateToProps = (state) => ({
	error: state.user.error,
	user: state.user.credentials,
	statusMessage: state.user.statusMessage
});

const mapDispatchToProps = {
	registerUser: userActions.registerUser,
	generateResetPassword: userActions.generateResetPassword,
	resetPassword: userActions.resetPassword,
	updateUserError: userActions.updateUserError,
	updateUserStatus: userActions.updateUserStatus,
	verifyEmail: userActions.verifyEmail
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterTeacher);
